import {
  AfterViewInit,
  Component,
  computed,
  effect,
  ErrorHandler,
  inject,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {JtmBannerService, KeepSessionAliveService, LocalStorageKeys} from '@jtm/jtm-services';
import {UntilDestroy} from '@jumio/portals.core';
import {ServiceUnavailableService} from '@jumio/portals.core-ui';
import {J4ErrorHandler} from 'core/services';
import {Subscription} from 'rxjs';
import {ErrorDescriptor} from './models/error-descriptor';
import {LocalStorageService} from 'public-shared/services/local-storage/local-storage.service';
import {NotificationService} from 'public-shared/services/notification/notification.service';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('serviceUnavailable', {read: ViewContainerRef, static: true}) private serviceUnavailablePlaceholder:
    | ViewContainerRef
    | undefined;
  private readonly serviceUnavailableService = inject(ServiceUnavailableService);
  private localStorageService = inject(LocalStorageService);
  private readonly errorHandler = inject(ErrorHandler);
  private readonly keepSessionAlive = inject(KeepSessionAliveService);
  private jtmBannerService = inject(JtmBannerService);
  private notificationService = inject(NotificationService);

  public readonly subscription = new Subscription();

  public banner = computed(() => this.jtmBannerService.banner());
  public utc: number = Math.floor(new Date().getTime());
  public isHidden = signal<boolean>(false);

  constructor() {
    effect(
      () => {
        this.banner();
        const hiddenValue: string = localStorage.getItem(LocalStorageKeys.CP_BANNER_HIDDEN) || '';
        this.isHidden.set(hiddenValue === 'YES');
      },
      {allowSignalWrites: true}
    );
  }

  public ngOnInit(): void {
    this.serviceUnavailableService.register(this.serviceUnavailablePlaceholder);
    this.isHidden.set(this.localStorageService.isBannerHidden());

    this.subscription.add(
      (this.errorHandler as J4ErrorHandler).unavailableServiceSubject?.subscribe({
        next: (_error: ErrorDescriptor) => {
          this.serviceUnavailableService.show();
        },
        error: _error => {}
      })
    );

    this.keepSessionAlive.startTracking();
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.jtmBannerService.callGetBanner();
    }, 3000);
  }

  public hideBanner(): void {
    this.isHidden.set(true);
    this.localStorageService.setBannerHidden();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
